import { gql } from "@apollo/client";

export const GET_COURSES_LIST = gql`
  query getCourses($filter: CourseFilter!) {
    getCourses(filter: $filter) {
      meta {
        total
        page
        limit
      }
      records {
        id
        course_name
        status
        created_by_name
        created_at
        image_url
        display_name
        gcf_public_course_id
        npractice_practice_program_id
      }
    }
  }
`;

export const GET_SUBJECT_LIST = gql`
  query getSubjects($filter: SubjectFilter!) {
    getSubjects(filter: $filter) {
      meta {
        total
        page
        limit
      }
      records {
        id
        global_name
        gcf_public_subject_id
        status
        status
        subject_code
        image_url
        tags
        synonyms
        sbd_subject_id
        assets
        gcf_public_subject_name
        npractice_public_subject_id
        npractice_public_subject_name
        npractice_practice_subject_id
        npractice_practice_subject_name
        nexam_public_subject_id
        nexam_public_subject_name
        created_by_name
        created_at
      }
    }
  }
`;
export const GET_CHAPTER_LIST = gql`
  query getChapters($filter: ChapterFilter!) {
    getChapters(filter: $filter) {
      meta {
        total
        page
        limit
      }
      records {
        id
        global_name
        status
        created_by_name
        created_at
        gcf_public_chapter_id
        color_icon_url
        patch_icon_url
        status
        chapter_code
        image_url
        gcf_learn_chapter_id
        gcf_learn_chapter_name
        gcf_public_chapter_name
        npractice_public_chapter_id
        npractice_public_chapter_name
        npractice_practice_chapter_id
        npractice_practice_chapter_name
      }
    }
  }
`;

export const GET_TOPIC_LIST = gql`
  query getTopics($filter: TopicFilter!) {
    getTopics(filter: $filter) {
      meta {
        total
        page
        limit
      }
      records {
        id
        global_name
        status
        created_by_name
        created_at
        status
        gcf_public_topic_id
        topic_code
        image_url
        gcf_learn_topic_id
        gcf_learn_topic_name
        gcf_public_topic_name
        npractice_public_topic_id
        npractice_public_topic_name
        npractice_practice_topic_id
        npractice_practice_topic_name
      }
    }
  }
`;

export const GET_COURSE_CLASS_SUBJECT_CHAPTER_MAPPINGS = gql`
query GetCourseClassSubjectChapterMappings($filter: CourseClassSubjectChapterMappingFilter!) {
  getCourseClassSubjectChapterMappings(filter: $filter) {
    records {
        id
        global_course_id
        class_id
        class_name
        global_subject_id
        global_chapter_id
        is_program_hierarchy_enabled
        is_course_hierarchy_enabled
        status
        created_at
        created_by_id
        created_by_name
        updated_at
        updated_by_id
        updated_by_name
        id
        course {
            id
            course_name
            display_name
            image_url
            gcf_public_course_id
            npractice_practice_program_id
        }
        subject {
            id
            global_name
            image_url
        }
        chapter {
            id
            global_name
            image_url
            color_icon_url
            patch_icon_url
        }
    }
    meta {
      total
      page
      limit
    }
  }
}
`;

export const GET_COURSE_CLASS_SUBJECT_CHAPTER_TOPIC_MAP = gql`
query GetCourseClassSubjectChapterTopicMappings($filter: CourseClassSubjectChapterTopicFilter!) {
  getCourseClassSubjectChapterTopicMappings(filter: $filter) {
    meta {
        total
        page
        limit
    }
    records {
        id
        global_course_id
        class_id
        class_name
        global_subject_id
        global_chapter_id
        global_topic_id
        is_course_hierarchy_enabled
        is_program_hierarchy_enabled
        status
        created_at
        created_by_name
        updated_at
        updated_by_name
        course {
            id
            course_name
        }
        subject {
            id
            global_name
        }
        chapter {
            id
            global_name
        }
        topic {
            id
            global_name
        }
    }
  }
}
`;
